import { Button } from "GameObjects/UI/Button";
import * as Constants from "Data/Constants";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as SFX from "Data/SoundEffect";
import * as VO from "Data/VoiceOver";
import Settings from "Data/Settings";
import { FlyingGameLayout } from "Layouts/FlyingGameLayout";
import { AbstractGameState } from "./AbstractGameState";
import { DuckSwapGame } from "./DuckSwapGame";
import { RestStopGame } from "./RestStopGame";
import { ResultsScreen } from "./ResultsScreen";

import { FlyingGameObstacle } from "GameObjects/FlyingGame/FlyingGameObstacle";
import { FlyingGameDuck } from "GameObjects/FlyingGame/FlyingGameDuck";
import { FlyingGameProgressBar } from "GameObjects/FlyingGame/FlyingGameProgressBar";
import { Sine, TimelineLite, TimelineMax, TweenLite, TweenMax } from "gsap";
import GameState, { IDuckConfig, IRuntimeDuck } from "../Data/GameState";
import { IDuckState } from "../Data/GameState";
import { Background } from "GameObjects/UI/Background";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { FlyingGameArrowButton } from "GameObjects/FlyingGame/FlyingGameArrowButton";
import {Text} from "GameObjects/UI/Text";
import { Application } from "Application";

const obstacleDataLevel1 = [
    { sprite: "Cyberchase_Skyscraper_01", grounded: true, lanes: [2], name: "skyscraper", nameVO: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER, nameVO_article: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT, factVO: VO.FLYING_OBSTACLE_FACT_SKYSCRAPER },
    { sprite: "Cyberchase_GullFrames_01", frames: 6, lanes: [0, 1, 2], name: "gull", nameVO: VO.FLYING_OBSTACLE_NAME_GULL, nameVO_article: VO.FLYING_OBSTACLE_NAME_GULL_ALT, factVO: VO.FLYING_OBSTACLE_FACT_GULL, sfx: SFX.OBSTACLE_GULL },
    { sprite: "Cyberchase_Streetlamp_01", grounded: true, lanes: [2], name: "highway lamp", nameVO: VO.FLYING_OBSTACLE_NAME_STREETLAMP, nameVO_article: VO.FLYING_OBSTACLE_NAME_STREETLAMP_ALT, factVO: VO.FLYING_OBSTACLE_FACT_HIGHWAY_LAMP },
    { sprite: "Cyberchase_Fog_01", lanes: [0, 1, 2], name: "fog", nameVO: VO.FLYING_OBSTACLE_NAME_FOG, nameVO_article: VO.FLYING_OBSTACLE_NAME_FOG_ALT, factVO: VO.FLYING_OBSTACLE_FACT_FOG },
    { sprite: "Cyberchase_WindFrames_06", frames: 9, lanes: [0, 1, 2], name: "wind", nameVO: VO.FLYING_OBSTACLE_NAME_WIND, nameVO_article: VO.FLYING_OBSTACLE_NAME_WIND_ALT, factVO: VO.FLYING_OBSTACLE_FACT_WIND, sfx: SFX.OBSTACLE_WIND },
];

const obstacleDataLevel2 = [
    { sprite: "Cyberchase_Skyscraper_01", grounded: true, lanes: [2], name: "skyscraper", nameVO: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER, nameVO_article: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT, factVO: VO.FLYING_OBSTACLE_FACT_SKYSCRAPER },
    { sprite: "Cyberchase_Skyscraper_02", grounded: true, lanes: [1], name: "skyscraper", nameVO: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER, nameVO_article: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT, factVO: VO.FLYING_OBSTACLE_FACT_SKYSCRAPER },
    { sprite: "Cyberchase_GullFrames_01", frames: 6, lanes: [0, 1, 2], name: "gull", nameVO: VO.FLYING_OBSTACLE_NAME_GULL, nameVO_article: VO.FLYING_OBSTACLE_NAME_GULL_ALT, factVO: VO.FLYING_OBSTACLE_FACT_GULL, sfx: SFX.OBSTACLE_GULL },
    { sprite: "Cyberchase_Streetlamp_01", grounded: true, lanes: [2], name: "highway lamp", nameVO: VO.FLYING_OBSTACLE_NAME_STREETLAMP, nameVO_article: VO.FLYING_OBSTACLE_NAME_STREETLAMP_ALT, factVO: VO.FLYING_OBSTACLE_FACT_HIGHWAY_LAMP },
    { sprite: "Cyberchase_Streetlamp_02", grounded: true, lanes: [1], name: "highway lamp", nameVO: VO.FLYING_OBSTACLE_NAME_STREETLAMP, nameVO_article: VO.FLYING_OBSTACLE_NAME_STREETLAMP_ALT, factVO: VO.FLYING_OBSTACLE_FACT_HIGHWAY_LAMP },
    { sprite: "Cyberchase_Fog_01", lanes: [0, 1, 2], name: "fog", nameVO: VO.FLYING_OBSTACLE_NAME_FOG, nameVO_article: VO.FLYING_OBSTACLE_NAME_FOG_ALT, factVO: VO.FLYING_OBSTACLE_FACT_FOG },
    { sprite: "Cyberchase_WindFrames_06", frames: 9, lanes: [0, 1, 2], name: "wind", nameVO: VO.FLYING_OBSTACLE_NAME_WIND, nameVO_article: VO.FLYING_OBSTACLE_NAME_WIND_ALT, factVO: VO.FLYING_OBSTACLE_FACT_WIND, sfx: SFX.OBSTACLE_WIND },
];

const obstacleDataLevel3 = [
    { sprite: "Cyberchase_Skyscraper_01", grounded: true, lanes: [2], name: "skyscraper", nameVO: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER, nameVO_article: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT, factVO: VO.FLYING_OBSTACLE_FACT_SKYSCRAPER },
    { sprite: "Cyberchase_Skyscraper_02", grounded: true, lanes: [1], name: "skyscraper", nameVO: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER, nameVO_article: VO.FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT, factVO: VO.FLYING_OBSTACLE_FACT_SKYSCRAPER },
    { sprite: "Cyberchase_GullFrames_01", frames: 6, lanes: [0, 1, 2], name: "gull", nameVO: VO.FLYING_OBSTACLE_NAME_GULL, nameVO_article: VO.FLYING_OBSTACLE_NAME_GULL_ALT, factVO: VO.FLYING_OBSTACLE_FACT_GULL, sfx: SFX.OBSTACLE_GULL },
    { sprite: "Cyberchase_Streetlamp_01", grounded: true, lanes: [2], name: "highway lamp", nameVO: VO.FLYING_OBSTACLE_NAME_STREETLAMP, nameVO_article: VO.FLYING_OBSTACLE_NAME_STREETLAMP_ALT, factVO: VO.FLYING_OBSTACLE_FACT_HIGHWAY_LAMP },
    { sprite: "Cyberchase_Streetlamp_02", grounded: true, lanes: [1], name: "highway lamp", nameVO: VO.FLYING_OBSTACLE_NAME_STREETLAMP, nameVO_article: VO.FLYING_OBSTACLE_NAME_STREETLAMP_ALT, factVO: VO.FLYING_OBSTACLE_FACT_HIGHWAY_LAMP },
    { sprite: "Cyberchase_Fog_01", lanes: [0, 1, 2], name: "fog", nameVO: VO.FLYING_OBSTACLE_NAME_FOG, nameVO_article: VO.FLYING_OBSTACLE_NAME_FOG_ALT, factVO: VO.FLYING_OBSTACLE_FACT_FOG },
    { sprite: "Cyberchase_WindFrames_06", frames: 9, lanes: [0, 1, 2], name: "wind", nameVO: VO.FLYING_OBSTACLE_NAME_WIND, nameVO_article: VO.FLYING_OBSTACLE_NAME_WIND_ALT, factVO: VO.FLYING_OBSTACLE_FACT_WIND, sfx: SFX.OBSTACLE_WIND },
];

const laneData = [ // to match the comp
    { y: 410 - 384 - 146, height: 143, quack: "quack_lane_3", name: "top", nameVO: VO.AUDIO_DESCRIPTION_LANE_NAME_TOP, flockInLaneADVO: VO.AUDIO_DESCRIPTION_FLYING_LANE_TOP },
    { y: 410 - 384, height: 143, quack: "quack_lane_2", name: "middle", nameVO: VO.AUDIO_DESCRIPTION_LANE_NAME_MIDDLE, flockInLaneADVO: VO.AUDIO_DESCRIPTION_FLYING_LANE_MIDDLE },
    { y: 410 - 384 + 146, height: 143, quack: "quack_lane_1", name: "bottom", nameVO: VO.AUDIO_DESCRIPTION_LANE_NAME_BOTTOM, flockInLaneADVO: VO.AUDIO_DESCRIPTION_FLYING_LANE_BOTTOM },
];

export class FlyingGame extends AbstractGameState<typeof FlyingGameLayout> implements ReturnType<typeof FlyingGameLayout> {
    public static readonly NAME = "FlyingGame";
    public static increaseDifficultyNextRound: boolean = false;
    public static decreaseDifficultyNextRound: boolean = false;
    protected static firstTime: boolean = true;
    protected static readonly debugCollisions: boolean = false;
    private static readonly hasDodgedObstacleOfType: {[key: string] : boolean} = {};
    private static readonly hasHeardFactVO: {[key: string] : boolean} = {};
    private static adaptiveDifficulty: number = 0;
    private static watchoutcount: number = 0;

    public readonly layout = FlyingGameLayout;

    public readonly bg: PIXI.Sprite[];
    public readonly lanesBg: LayoutSprite;
    public readonly upButton: FlyingGameArrowButton;
    public readonly downButton: FlyingGameArrowButton;

    public readonly progressBarBg: LayoutSprite;
    public readonly progressBarFill: LayoutSprite;
    public readonly progressBarStartIcon: LayoutSprite;
    public readonly progressBarRestStopMarkerVisited: LayoutSprite;
    public readonly progressBarRestStopMarker: LayoutSprite;
    public readonly progressBarDestinationIcon: LayoutSprite;

    protected bgContainer = this.addChildAt(new Background(), 0);
    protected lanesContainer = this.addChild(new PIXI.Container());
    protected obstaclesContainer = this.addChild(new PIXI.Container());
    protected progressBarContainer = this.addChild(new PIXI.Container());
    protected ducksContainer = this.addChild(new PIXI.Container());

    protected obstacles: FlyingGameObstacle[] = [];
    protected currentLane = 1;
    protected previousLane = 1;

    protected ducks: FlyingGameDuck[] = [];
    protected laneChangeTimeline = new TimelineMax();

    protected progressBar: FlyingGameProgressBar;

    protected restStopTimeline?: TimelineLite;
    protected restoriaTimeline?: TimelineLite;
    protected duckHoverTimeline?: TimelineMax;
    protected obstacleSpawnTimeline?: TimelineMax;
    protected goToDuckSwapTimeline?: TimelineLite;

    protected collisionsEnabled: boolean = true;

    protected lastObstacleSpawnedinCurrentLane = false;

    protected paused: boolean = false;

    protected bgm = HLF.Application.instance.audio.getAudioTrack("flyingloop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("flyingloop", HLF.AudioCategory.BGM);

    private readonly bgScrollSpeed = 75;

    private hasDodgedAnObstacle: number = 0;
    private hasCollidedWithAnObstacle: boolean = false;
    private onboardingStep = 0;

    public constructor() {
        super();
        this.bg = [
            this.bgContainer.addChild(new PIXI.Sprite(HLF.PixiUtils.getTexture("Cyberchase_PanningBGTiled_L"))),
            this.bgContainer.addChild(new PIXI.Sprite(HLF.PixiUtils.getTexture("Cyberchase_PanningBGTiled_R"))),
        ];
        this.bg[0].anchor.set(0, 0);
        this.bg[1].anchor.set(0, 0);
        this.bg[1].position.x = this.bg[0].width;
        this.lanesBg = new LayoutSprite();
        this.upButton = new FlyingGameArrowButton(this.onUpButtonPressed.bind(this), VO.UP);
        this.downButton = new FlyingGameArrowButton(this.onDownButtonPressed.bind(this), VO.DOWN);

        this.progressBarBg = new LayoutSprite();
        this.progressBarFill = new LayoutSprite();
        this.progressBarStartIcon = new LayoutSprite();
        this.progressBarRestStopMarkerVisited = new LayoutSprite();
        this.progressBarRestStopMarker = new LayoutSprite();
        this.progressBarDestinationIcon = new LayoutSprite();
        this.progressBar = new FlyingGameProgressBar();
    }

    public init(pSize: PIXI.Point, pData: { name: string, from?: string, ducks?: IRuntimeDuck[], wasCorrectSwap?: boolean }) {
        super.init(pSize, pData);

        PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, false);

        this.onKeyDown = this.onKeyDown.bind(this);
        window.addEventListener(HLF.Input.Events.KEY_DOWN, this.onKeyDown, false);

        // adaptive difficulty
        if (Settings.difficulty === 0) {
            if (FlyingGame.decreaseDifficultyNextRound === true) {
                if (Settings.obstacleSpeed > 0) {
                    console.log("adaptive difficulty: decreasing obstacle speed");
                    Settings.obstacleSpeed -= 1/7;
                }
                if (FlyingGame.adaptiveDifficulty > 1/3) {
                    console.log("adaptive difficulty: spawning easier obstacles");
                    FlyingGame.adaptiveDifficulty -= 1/3;
                }
            }
            else if (FlyingGame.increaseDifficultyNextRound === true) {
                if (Settings.obstacleSpeed < 1) {
                    if (Settings.audioDescriptionEnabled) {
                        if (Settings.obstacleSpeed < (1/7)) {
                            console.log("adaptive difficulty: increasing obstacle speed");
                            Settings.obstacleSpeed += 1/7;
                        }
                        else {
                            console.log("adaptive difficulty: NOT increasing obstacle speed, because audio descriptions are enabled");
                        }
                    }
                    else {
                        console.log("adaptive difficulty: increasing obstacle speed");
                        Settings.obstacleSpeed += 1/7;
                    }
                }
                if (FlyingGame.adaptiveDifficulty < 1) {
                    console.log("adaptive difficulty: spawning harder obstacles");
                    FlyingGame.adaptiveDifficulty += 1/3;
                }
            }
        }

        FlyingGame.decreaseDifficultyNextRound = false;
        FlyingGame.increaseDifficultyNextRound = true;

        this.lanesContainer.addChild(this.lanesBg);
        this.progressBarContainer.addChild(this.progressBarBg);
        this.progressBarContainer.addChild(this.progressBar);
        this.progressBarContainer.addChild(this.progressBarFill);
        this.progressBarContainer.addChild(this.progressBarStartIcon);
        this.progressBarContainer.addChild(this.progressBarRestStopMarkerVisited);
        this.progressBarContainer.addChild(this.progressBarRestStopMarker);
        this.progressBarContainer.addChild(this.progressBarDestinationIcon);

        this.addChild(this.upButton);
        this.addChild(this.downButton);

        if (HLF.PlatformUtils.isMobile()) {
            HLF.LogUtils.log("Using mobile positioning for arrow buttons", {className: FlyingGame.NAME, color: HLF.LogUtils.COLOR_LIGHT_BLUE});
            this.upButton.y -= 12.5;
            this.downButton.y -= 12.5;
        }

        if (pData.ducks === undefined) {
            console.log("initializing ducks with new data");
            let ducksCount = 5;
            if (Settings.difficulty === (2/3)) {
                ducksCount = 7;
            }
            else if (Settings.difficulty === (3/3)) {
                ducksCount = 9;
            }
            pData.ducks = GameState.GetDucks(ducksCount);
            HLF.ArrayUtils.shuffle(pData.ducks);
            console.log("resetting progress bar to zero")
            GameState.flyingTimeElapsed = 0;
        }
        else {
            console.log("got ducks data from previous scene");
        }

        this.initDucks(pData.ducks);

        this.initRestStops();

        if (GameState.freePlay === false) {
            this.initProgressBar();
        }
        else {
            this.progressBarContainer.visible = false;
        }

        this.initArrowButtons();

        if (FlyingGame.firstTime && pData.from === DuckSwapGame.NAME) {
            FlyingGame.firstTime = false;
            HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_5B, HLF.PlayMode.Append);
        }
        else if (FlyingGame.firstTime && pData.from === RestStopGame.NAME) {
            FlyingGame.firstTime = false;
        }
    }

    public destroy(pOptions: Parameters<typeof HLF.State.prototype.destroy>[0]) {
        super.destroy(pOptions);
        this.restStopTimeline?.kill();
        this.restoriaTimeline?.kill();
        this.obstacleSpawnTimeline?.kill();
        this.duckHoverTimeline?.kill();
        this.goToDuckSwapTimeline?.kill();
    }

    public gotoNextState(name: string, data?: object) {
        if (GameState.freePlay === false) {
            GameState.flyingTimeElapsed = this.restStopTimeline?.time() ?? this.restoriaTimeline?.time() ?? 0;
        }
        window.removeEventListener(HLF.Input.Events.KEY_DOWN, this.onKeyDown, false);
        HLF.Application.instance.audio.stop(SFX.WING_FLAPPING, HLF.AudioCategory.SFX);
        PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, true);
        super.gotoNextState(name, {ducks: this.ducks, ...data});
    }

    public animateIn(pOnComplete: () => void) {
        this.ducks.forEach(d=>d.update(0)); // TODO: flap wings while loading screen is still fading out

        HLF.Application.instance.audio.play(SFX.WING_FLAPPING, 1, true, HLF.AudioCategory.SFX);

        if (Settings.closedCaptionsEnabled === true || Settings.voiceoverVolume > 0) {
            this.settingsButton.visible = false;
            this.helpButton.visible = false;
        }

        this.upButton.interactive = false;
        this.downButton.interactive = false;

        if (FlyingGame.firstTime && !GameState.freePlay) {
            this.downButton.setInteractive(false);
            this.upButton.setInteractive(false);
        }

        const spawnFirstObstacle = ()=>{
            this.obstacleSpawnTimeline = new TimelineMax();
            this.obstacleSpawnTimeline.repeat(-1);

            const delayBetweenObstacles = 9 * (1 - Settings.obstacleSpeed + 1/7);

            if (FlyingGame.firstTime && !GameState.freePlay) {
                Application.instance.analytics.event("tutorial_begin", FlyingGame.NAME);

                HLF.Application.instance.voiceover.playVO([
                    VO.FLYING_ONBOARDING_1,
                ], HLF.PlayMode.Append);
            }
            else {
                this.settingsButton.visible = true;
                this.helpButton.visible = true;
                // spawn second obstacle in random lane, 6 seconds later
                this.obstacleSpawnTimeline.call(()=>this.spawnObstacle(), undefined, undefined, delayBetweenObstacles);
            }

            console.log("spawn first obstacle");
            this.spawnObstacle(1); // always spawn first obstacle in middle lane

            const focusables = [
                this.upButton,
                this.downButton,
            ];
            focusables.forEach(button => button.interactive = false); // hack: set interactive to false so keyboard focus doesn't immediately jump to first item
            PubSub.publishSync(HLF.REGISTER_FOCUSABLES, focusables);
            focusables.forEach(button => button.interactive = true);
        }

        if (GameState.freePlay === false) {
            for (let i = 0; i < GameState.restStops.length; i++) {
                const timeUntilRestStop = GameState.restStops[i] - GameState.flyingTimeElapsed;
                if (timeUntilRestStop > 0) {
                    console.log(timeUntilRestStop + "s until next rest stop");
                    this.startRestStopTimer(GameState.restStops[i], GameState.flyingTimeElapsed);
                    break;
                }
            }
            if (this.restStopTimeline === undefined) {
                const timeUntilDestination = GameState.totalFlyingTime - GameState.flyingTimeElapsed;
                console.log("no more rest stops. " + timeUntilDestination + "s until destination");
                this.startRestoriaTimer(GameState.totalFlyingTime, GameState.flyingTimeElapsed);
            }
        }
        else {
            console.log("Training (free play) mode -- Rest Stop will not happen automatically");
            GameState.flyingTimeElapsed = 0;
        }

        if (Settings.audioDescriptionEnabled) {
            if (FlyingGame.firstTime) {
                HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_1, {
                    mode: HLF.PlayMode.Append, priority: 5
                });
                HLF.Application.instance.voiceover.playVO([
                    VO.AUDIO_DESCRIPTION_FLYING_INTRO_1A,
                    this.ducks[0].config.nameVO_flying,
                    VO.AUDIO_DESCRIPTION_FLYING_INTRO_1B,
                ], {
                    caption: {
                        id: VO.AUDIO_DESCRIPTION_FLYING_INTRO_1A,
                        args: {
                            "DUCK": this.ducks[0].config.nameVO_flying,
                            "_": VO.AUDIO_DESCRIPTION_FLYING_INTRO_1B, // hack to extend the duration of the caption
                        }
                    },
                    mode: HLF.PlayMode.Append, priority: 5});

                if (!GameState.freePlay) {
                    HLF.Application.instance.voiceover.playVO(VO.AUDIO_DESCRIPTION_FLYING_INTRO_2, {mode: HLF.PlayMode.Append, priority: 5});

                    if (GameState.restStops.length === 1) {
                        HLF.Application.instance.voiceover.playVO(VO.AUDIO_DESCRIPTION_FLYING_INTRO_2B, {mode: HLF.PlayMode.Append, priority: 5});
                    }
                    else if (GameState.restStops.length === 2) {
                        HLF.Application.instance.voiceover.playVO(VO.AUDIO_DESCRIPTION_FLYING_INTRO_2C, {mode: HLF.PlayMode.Append, priority: 5});
                    }
                }
                HLF.Application.instance.voiceover.playVO(VO.AUDIO_DESCRIPTION_FLYING_INTRO_3, {mode: HLF.PlayMode.Append, priority: 5});
                HLF.Application.instance.voiceover.playVO(laneData[this.currentLane].flockInLaneADVO, {mode: HLF.PlayMode.Append, callback: ()=>{
                    spawnFirstObstacle();
                }, priority: 5});
            }
            else {
                spawnFirstObstacle();
                HLF.Application.instance.voiceover.playVO(laneData[this.currentLane].flockInLaneADVO, HLF.PlayMode.Append);
            }
        }
        else {
            if (FlyingGame.firstTime && (Settings.voiceoverVolume > 0 || Settings.closedCaptionsEnabled)) {
                HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_1, ()=>{
                    spawnFirstObstacle();
                });
            }
            else {
                spawnFirstObstacle();
            }
        }
        super.animateIn(pOnComplete);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.bgContainer.x = (0 - (pSize.x - 1024) / 2);

        this.lanesBg.width = pSize.x;
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);

        if (!Application.instance.paused) {
            if (!this.paused) {
                this.updateProgressBar(pDeltaTime);
                this.updateObstaclePositions(pDeltaTime);
            }
            this.checkForCollisions();
            if (!this.paused) {
                this.drainDuckEnergy(pDeltaTime);
            }
            this.cleanupOffscreenObstacles();
            this.checkIfNeedsSwap();
            if (GameState.freePlay === true) {
                GameState.flyingTimeElapsed += pDeltaTime;
            }

            if (!this.paused) {
                this.bg[0].position.x -= this.bgScrollSpeed * pDeltaTime * (Settings.obstacleSpeed + (1/7));
                this.bg[1].position.x -= this.bgScrollSpeed * pDeltaTime * (Settings.obstacleSpeed + (1/7));

                if (this.bg[0].position.x <= (0 - this.bg[0].width)) {
                    this.bg[0].position.x += this.bg[0].width + this.bg[1].width;
                    [this.bg[0], this.bg[1]] = [this.bg[1], this.bg[0]]; // https://flaviocopes.com/javascript-swap-array-elements/
                }
            }

            this.ducks.forEach(d=>d.update(pDeltaTime)); // flap
            this.obstacles.forEach(o=>o.update(pDeltaTime)); // animate
        }
    }

    public pause() {
        this.restStopTimeline?.pause();
        this.restoriaTimeline?.pause();
        this.obstacleSpawnTimeline?.pause();
        this.obstacleSpawnTimeline?.repeat(0);
        this.goToDuckSwapTimeline?.pause();
        this.paused = true;
    }

    public resume() {
        this.restStopTimeline?.resume();
        this.restoriaTimeline?.resume();
        this.obstacleSpawnTimeline?.resume();
        this.obstacleSpawnTimeline?.repeat(-1);
        this.goToDuckSwapTimeline?.resume();
        this.paused = false;
    }

    protected initRestStops() {
        if (GameState.flyingTimeElapsed === 0) {
            if (FlyingGame.firstTime === true && Settings.obstacleSpeed <= 1 / 7) {
                if (Settings.audioDescriptionEnabled === true) {
                    GameState.totalFlyingTime = 120;
                    GameState.restStops = [90];
                }
                else {
                    GameState.totalFlyingTime = 90;
                    GameState.restStops = [60];
                }
            }
            else {
                if (Settings.audioDescriptionEnabled === true && Settings.obstacleSpeed <= 1 / 7) {
                    GameState.totalFlyingTime = 240;
                    if (this.ducks.length === 5) {
                        GameState.restStops = [120];
                    }
                    else {
                        GameState.restStops = [80, 160];
                    }
                }
                else {
                    GameState.totalFlyingTime = 180;
                    if (this.ducks.length === 5) {
                        GameState.restStops = [90];
                    }
                    else {
                        GameState.restStops = [60, 120];
                    }
                }
            }
        }
    }

    protected checkIfNeedsSwap() {
        if (FlyingGame.firstTime && this.onboardingStep < 5 && !GameState.freePlay) {
            return;
        }
        let elapsedTime: number;

        if (GameState.freePlay === true) {
            elapsedTime = GameState.flyingTimeElapsed;
        }
        else {
            elapsedTime = (this.restStopTimeline?.time() ?? this.restoriaTimeline?.time() ?? GameState.flyingTimeElapsed) - GameState.flyingTimeElapsed;
        }
        const anyTwoDucksHaveTwoOrMoreEnergyOutOfFive = this.ducks.filter(d => (Math.floor(d.energy / 20) || Math.round(d.energy / 20)) >= 2).length >= 2;

        const leadDuckHasLessThan50PercentEnergy = this.ducks[0].energy <= 50;

        let enoughTimeRemaining = true;
        const enoughTimeElapsed = elapsedTime > 10;

        if (this.restStopTimeline) {
            let minDurationAfterDuckSwap;
            if (Settings.audioDescriptionEnabled === true && Settings.obstacleSpeed <= 1/7) {
                minDurationAfterDuckSwap = 15;
            }
            else {
                minDurationAfterDuckSwap = 10;
            }
            if ((this.restStopTimeline?.duration() - this.restStopTimeline?.time() < minDurationAfterDuckSwap)) {
                enoughTimeRemaining = false;
            }
        }

        if (this.restoriaTimeline) {
            const minDurationAfterDuckSwap = 15;
            if ((this.restoriaTimeline?.duration() - this.restoriaTimeline?.time() < minDurationAfterDuckSwap)) {
                enoughTimeRemaining = false;
            }
        }

        if (enoughTimeElapsed && leadDuckHasLessThan50PercentEnergy && anyTwoDucksHaveTwoOrMoreEnergyOutOfFive && enoughTimeRemaining && this.goToDuckSwapTimeline === undefined) {
            if (this.restStopTimeline?.isActive()) {
                this.restStopTimeline.pause();
            }

            if (this.restoriaTimeline?.isActive()) {
                this.restoriaTimeline.pause();
            }

            if (this.obstacleSpawnTimeline?.isActive()) {
                this.obstacleSpawnTimeline.pause();
            }

            this.collisionsEnabled = false;

            this.upButton.interactive = false;
            this.downButton.interactive = false;
            PubSub.publishSync(HLF.CLEAR_FOCUS);
            PubSub.publishSync(HLF.UNREGISTER_FOCUSABLES, [
                this.homeButton,
                this.settingsButton,
                this.helpButton,
                this.upButton,
                this.downButton,
            ]);
            this.homeButton.setInteractive(false)
            this.helpButton.setInteractive(false)
            this.settingsButton.setInteractive(false)
            this.upButton.setInteractive(false)
            this.downButton.setInteractive(false);

            this.goToDuckSwapTimeline = new TimelineLite();

            HLF.Application.instance.voiceover.playVO([this.ducks[0].config.nameVO_flying, VO.FLYING_INSTRUCTIONS_4], {
                caption: {
                    id: VO.FLYING_INSTRUCTIONS_4,
                    args: {
                        "DUCK": this.ducks[0].config.nameVO_flying,
                    },
                },
                priority: 5, callback: ()=>{
                if (this.goToDuckSwapTimeline?.isActive()) {
                    this.goToDuckSwapTimeline!.call(()=>{
                        this.gotoNextState(DuckSwapGame.NAME);
                    });
                }
                else {
                    this.gotoNextState(DuckSwapGame.NAME);
                }
            }});
            this.ducks[0].playTiredAnimation();
            this.goToDuckSwapTimeline.to([this.upButton, this.downButton], 1, {
                pixi: {y: this._size.y + 112.5, alpha: 0}
            }, 0);
            this.goToDuckSwapTimeline.to(this.obstacles, 2, {
                pixi: {alpha: 0},
            }, 0);
            this.goToDuckSwapTimeline.to(this.ducks[0], 0.25, {
                pixi: {tint: 0xff0000, alpha: 0.5}
            }, 0);
            this.goToDuckSwapTimeline.to(this.ducks[0], 0.25, {
                pixi: {tint: 0xffffff, alpha: 1}
            });
            this.goToDuckSwapTimeline.to(this.ducks[0], 0.25, {
                pixi: {tint: 0xff0000, alpha: 0.5}
            });
            this.goToDuckSwapTimeline.to(this.ducks[0], 0.25, {
                pixi: {tint: 0xffffff, alpha: 1}
            });
            this.goToDuckSwapTimeline.to([this.progressBarContainer], 1, {
                pixi: {y: -200, alpha: 0}
            });


        }
    }

    protected disableDwellOnInit() {
        // don't call super.disableDwellOnInit for this state only
    }

    protected initDucks(pDucks: IRuntimeDuck[]) {
        for (let i = 0; i < pDucks.length; i++) {
            const duck = new FlyingGameDuck(pDucks[i].config, pDucks[i]);
            duck.scale.set(pDucks[i].config.scale ?? 1);

            if (i > 0) {
                if (i <= 2) {
                    duck.following = this.ducks[0];
                }
                else {
                    duck.following = this.ducks[i - 2];
                }
            }
            this.ducks.push(this.ducksContainer.addChild(duck));
        }

        this.layoutDucksInV({ animate: false });

        this.duckHoverTimeline = new TimelineMax();
        this.duckHoverTimeline.repeat(-1);
        // duckHoverTimeline.repeatDelay(0.2);
        this.duckHoverTimeline.staggerFromTo(this.ducks.map(duck => duck.sprite), 0.5, {
            pixi: {
                anchorY: 0.45,
            },
        },
            {
                pixi: {
                    anchorY: 0.55,
                },
                ease: Sine.easeInOut,
            }, 0.025)
            .staggerFromTo(this.ducks.map(duck => duck.sprite), 0.45, {
                pixi: {
                    anchorY: 0.55,
                },
            },
                {
                    pixi: {
                        anchorY: 0.45,
                    },
                    ease: Sine.easeInOut
                }, 0.05);
    }

    protected initArrowButtons() {
        const canGoUp = this.currentLane > 0;
        const canGoDown = this.currentLane < laneData.length - 1;
        this.upButton.setInteractive(canGoUp === true);
        this.downButton.setInteractive(canGoDown === true);
    }

    protected initProgressBar() {
        console.log("total: " + GameState.totalFlyingTime + "s, elapsed: " + GameState.flyingTimeElapsed + "s")
        this.progressBar.setForegroundTexture(this.progressBarFill.texture, this.progressBarFill.height / 2, this.progressBarFill.height / 2);
        this.progressBar.position.copyFrom(this.progressBarFill);
        this.progressBarFill.visible = false;
        this.progressBar.setDuration(GameState.totalFlyingTime);
        for (let i = 0; i < GameState.restStops.length; i++) {
            if (GameState.restStops[i] > GameState.flyingTimeElapsed) {
                const marker = this.progressBar.addRestStop({time: GameState.restStops[i], sprite: this.progressBarRestStopMarker, visited: false});
                const line = marker.addChild(HLF.PixiUtils.makeSprite("cyberchase-flying-dots-white"));
                line.anchor.set(0.55, 0); // eyeballed
            }
            else {
                const marker = this.progressBar.addRestStop({time: GameState.restStops[i], sprite: this.progressBarRestStopMarkerVisited, visited: true});
                const line = marker.addChild(HLF.PixiUtils.makeSprite("cyberchase-flying-dots-black"));
                line.anchor.set(0.55, 0); // eyeballed
            }
        }

        this.progressBarRestStopMarker.visible = false;
        this.progressBarRestStopMarkerVisited.visible = false;

        this.progressBar.setProgress(GameState.flyingTimeElapsed);
    }

    protected updateProgressBar(pDeltaTime: number) {
        if (this.restStopTimeline?.isActive() || this.restoriaTimeline?.isActive() && !this.obstacleSpawnTimeline?.paused()) {
            this.progressBar.update(pDeltaTime);
        }
    }

    protected drainDuckEnergy(pDeltaTime: number) {
        const leadDuckDrainSpeed = 100; // percent per second
        const collisionDrainSpeed = 50; // percent per second
        const rechargeSpeed = GameState.freePlay ? 75 : 50; // percent per second
        const leadDuckMaxEfficiency = 100;

        const nonLeadDuckMaxEfficiency = 80; // TODO: randomize per duck

        this.ducks.forEach((duck, i) => {
            if (duck.isColliding) { // collisions drains energy
                duck.efficiency -= collisionDrainSpeed * pDeltaTime;
            }
            else if (i === 0) { // lead duck drains energy
                duck.maxEfficiency = leadDuckMaxEfficiency;
                duck.efficiency -= leadDuckDrainSpeed * pDeltaTime;
            }
            else if (duck.following !== undefined) {
                // ducks with 0 energy or during collisions don't provide a draft to ducks behind them
                if (duck.following.isColliding) {
                    duck.maxEfficiency = leadDuckMaxEfficiency;
                    duck.efficiency -= leadDuckDrainSpeed * pDeltaTime;
                }
                // ducks with 0 energy cause ducks also don't provide a draft to ducks behind them
                else if ( duck.following.energy === 0) {
                    duck.maxEfficiency = leadDuckMaxEfficiency;
                    duck.efficiency -= leadDuckDrainSpeed * pDeltaTime;
                }
                else { // flying behind another duck recharges efficiency
                    if (duck.following.efficiency === 0) {
                        duck.maxEfficiency = leadDuckMaxEfficiency;
                    }
                    else {
                        duck.maxEfficiency = nonLeadDuckMaxEfficiency;
                    }
                    duck.efficiency += rechargeSpeed * pDeltaTime;
                }
            }
            else {
                // this should never happen
                throw new Error("duck.following is undefined (and duck is not lead duck)");
            }

            duck.energy -= ((100 - duck.efficiency) / 100) * pDeltaTime;
        });
    }

    protected checkForCollisions() {

        if (this.collisionsEnabled === false) {
            return;
        }

        /** hit test two axis-aligned bounding boxes */
        const hitTest = (x1: number, y1: number, w1: number, h1: number, x2: number, y2: number, w2: number, h2: number) => {
            if (x1 + w1 > x2) {
                if (x1 < x2 + w2) {
                    if (y1 + h1 > y2) {
                        if (y1 < y2 + h2) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };

        /** hit test a circle with an axis-aligned bounding box */
        const hitTest2 = (circleX: number, circleY: number, circleRadius: number, rectX: number, rectY: number, rectWidth: number, rectHeight: number) => {
            const deltaX = circleX - Math.max(rectX, Math.min(circleX, rectX + rectWidth));
            const deltaY = circleY - Math.max(rectY, Math.min(circleY, rectY + rectHeight));
            return (deltaX * deltaX + deltaY * deltaY) < (circleRadius * circleRadius);
        }


        this.ducks.forEach((duck, i) => {
            this.obstacles.forEach(obstacle => {
                const b1 = HLF.PixiUtils.getGlobalBounds(duck);
                const duckRadius = 15;
                const b2 = HLF.PixiUtils.getGlobalBounds(obstacle);
                b2.width /= 2; // collide only with the front half of the obstacle
                // if (hitTest(b1.x, b1.y, b1.width, b1.height, b2.x, b2.y, b2.width, b2.height)) {
                if (hitTest2(b1.x + b1.width / 2, b1.y + b1.height / 2, duckRadius, b2.x, b2.y, b2.width, b2.height)) {
                    if (!duck.isColliding) {
                        if (
                            (obstacle.lane === this.currentLane) ||
                            (obstacle.isGrounded && obstacle.lane <= this.currentLane) ||
                            (this.laneChangeTimeline?.isActive() && obstacle.lane === this.previousLane)
                        ) {
                            console.log("duck in lane " + this.currentLane.toFixed(0) + " collided with obstacle in lane " + obstacle.lane.toFixed(0));
                            this.onDuckCollidedWithObstacle(duck, obstacle);
                            if (FlyingGame.debugCollisions) {
                                const g = Application.instance.stage.addChild(new PIXI.Graphics());
                                g.position.set(-this.x, -this.y);
                                g.scale.set(Application.instance.renderer.resolution);
                                g.lineStyle(1, 0x00ffff);
                                g.drawRect(b1.x, b1.y, b1.width, b1.height);
                                g.lineStyle(1, 0x00ff00);
                                g.drawCircle(b1.x + b1.width / 2, b1.y + b1.height / 2, duckRadius);
                                g.lineStyle(1, 0xff0000);
                                g.drawRect(b2.x, b2.y, b2.width, b2.height);
                                TweenLite.delayedCall(0.5, ()=>{
                                    g.destroy();
                                });
                            }
                            return; // break out of inner foreach (i.e. only one obstacle per duck per frame)
                        }
                    }
                }
            });
        });
    }

    protected onUpButtonPressed(pOptions?: {fake: boolean}) {
        if (pOptions?.fake) {
            this.upButton.simulateClick();
        }
        if (!this.upButton.isInteractive) {
            return;
        }
        if (this.currentLane === 0) {
            return;
        }
        if (this.paused) {
            this.resume();
        }
        this.upButton.stopPulse();
        this.downButton.stopPulse();

        const prevLane = laneData[this.currentLane];
        this.previousLane = this.currentLane;
        this.currentLane--;

        this.layoutDucksInV({animate: true});
        HLF.Application.instance.audio.play(laneData[this.currentLane].quack, 1, false, HLF.AudioCategory.SFX);

        if (Settings.audioDescriptionEnabled) {
            HLF.Application.instance.voiceover.playVO(laneData[this.currentLane].flockInLaneADVO, {priority: 4});
        }

        const canGoUp = this.currentLane > 0;
        const canGoDown = this.currentLane < laneData.length - 1;
        if (FlyingGame.firstTime === true && this.onboardingStep === 1) {
            this.onboardingStep++;
            this.upButton.setInteractive(false);
            this.downButton.setInteractive(false);
        }
        else {
            this.upButton.setInteractive(canGoUp === true);
            this.downButton.setInteractive(canGoDown === true);
        }
    }

    protected onDownButtonPressed(pOptions?: {fake: boolean}) {
        if (pOptions?.fake) {
            this.downButton.simulateClick();
        }
        if (!this.downButton.isInteractive) {
            return;
        }
        if (this.currentLane === laneData.length - 1) {
            return;
        }
        if (this.paused) {
            this.resume();
        }
        this.upButton.stopPulse();
        this.downButton.stopPulse();

        const prevLane = laneData[this.currentLane];
        this.previousLane = this.currentLane;
        this.currentLane++;

        this.layoutDucksInV({animate: true});
        HLF.Application.instance.audio.play(laneData[this.currentLane].quack, 1, false, HLF.AudioCategory.SFX);

        if (Settings.audioDescriptionEnabled) {
            HLF.Application.instance.voiceover.playVO(laneData[this.currentLane].flockInLaneADVO, {priority: 4});
        }

        if (this.onboardingStep === 2) {
            this.onboardingStep++;
        }

        const canGoUp = this.currentLane > 0;
        const canGoDown = this.currentLane < laneData.length - 1;
        this.upButton.setInteractive(canGoUp === true);
        this.downButton.setInteractive(canGoDown === true);
    }

    protected spawnObstacle(pLaneNumber?: number) {
        let laneNumber: number;

        if (pLaneNumber === undefined) {
            const lastObstacleSpawned: FlyingGameObstacle | undefined = this.obstacles[this.obstacles.length - 1];
            if (lastObstacleSpawned !== undefined && lastObstacleSpawned.lane === 1 && lastObstacleSpawned.isGrounded === true) {
                // if the most recent obstacle blocked both the middle and the bottom lane, never spawn the next obstacle in the top lane
                laneNumber = HLF.Random.intBetween(1, laneData.length);
            }
            else if (this.lastObstacleSpawnedinCurrentLane === false) {
                laneNumber = this.currentLane; // every 2nd obstacle will force a lane change
            }
            else {
                laneNumber = HLF.Random.intBetween(0, laneData.length);
            }
            this.lastObstacleSpawnedinCurrentLane = this.currentLane === laneNumber;
        }
        else {
            laneNumber = pLaneNumber;
        }

        let data;
        let speed;

        if (Settings.difficulty === 0) {
            switch (FlyingGame.adaptiveDifficulty) {
                default:
                case 0:
                case 1 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel1.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
                case 2 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel2.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
                case 3 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel3.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
            }
        }
        else {
            switch (Settings.difficulty) {
                default:
                case 1 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel1.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
                case 2 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel2.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
                case 3 / 3:
                    data = HLF.ArrayUtils.random(obstacleDataLevel3.filter(o => o.lanes.indexOf(laneNumber) > -1));
                    break;
            }
        }

        // if/else instead of switch because of floating point math
        if (Settings.obstacleSpeed < 1 / 7) {
            speed = 50;
        }
        else if (Settings.obstacleSpeed < 2 / 7) {
            speed = 50 * 1.5;
        }
        else if (Settings.obstacleSpeed < 3 / 7) {
            speed = 50 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 4 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 5 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 6 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 7 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.25;
        }

        const lane = laneData[laneNumber];

        let newObstacle;

        if (data === undefined) {
            throw new Error("can't spawn undefined obstacle");
        }

        if (data.frames) {
            newObstacle = new FlyingGameObstacle(
                {texture: data.sprite, frames: data.frames},
                speed,
                laneNumber,
                data.grounded ?? false,
                data.name,
                data.nameVO,
                data.nameVO_article,
                data.factVO,
            );
        }
        else {
            newObstacle = new FlyingGameObstacle(
                data.sprite,
                speed,
                laneNumber,
                data.grounded ?? false,
                data.name,
                data.nameVO,
                data.nameVO_article,
                data.factVO,
            );
        }

        const spawnPos = {
            x: 1024 - (1024 - this._size.x) / 2 + (newObstacle.width / 2),
            y: (this._size.y / 2) + lane.y,
        };

        if (data.grounded) {
            spawnPos.y = this._size.y;
        }

        newObstacle.position.copyFrom(spawnPos);
        this.obstacles.push(this.obstaclesContainer.addChild(newObstacle));

        if (Settings.audioDescriptionEnabled) {
            if (data.grounded && lane.nameVO !== VO.AUDIO_DESCRIPTION_LANE_NAME_BOTTOM) {
                HLF.Application.instance.voiceover.playVO([
                    data.nameVO_article,
                    VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_A,
                    lane.nameVO,
                    VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B,
                    VO.AND,
                    VO.AUDIO_DESCRIPTION_LANE_NAME_BOTTOM,
                    VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B,
                ], {priority: 4, mode: HLF.PlayMode.Override, caption: {
                    id: "inez_audio_description_flying_obstacle_a_multiple",
                    args: {
                        "OBSTACLE": data.nameVO_article,
                        "LOCATION1": lane.nameVO,
                        "LOCATION2": VO.AUDIO_DESCRIPTION_LANE_NAME_BOTTOM,
                        "_": VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B, // hack to extend duration of caption
                        "__": VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B,
                        "___": VO.AND,
                    },
                }});
            }
            else {
                HLF.Application.instance.voiceover.playVO([
                    data.nameVO_article,
                    VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_A,
                    lane.nameVO,
                    VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B,
                ], {priority: 4, mode: HLF.PlayMode.Override, caption: {
                    id: VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_A,
                    args: {
                        "OBSTACLE": data.nameVO_article,
                        "LOCATION": lane.nameVO,
                        "_": VO.AUDIO_DESCRIPTION_FLYING_OBSTACLE_B, // hack to extend duration of caption
                    },
                }});
            }
        }
        else if (FlyingGame.watchoutcount < 3) {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_3, {mode: HLF.PlayMode.New, priority: 0, callback: (pDidPlay)=>{
                if (pDidPlay) {
                    FlyingGame.watchoutcount++;
                }
            }});
        }

        const factVO = data.factVO;
        if (FlyingGame.hasHeardFactVO[factVO] !== true && FlyingGame.firstTime !== true) {
            HLF.Application.instance.voiceover.playVO(factVO, {mode: HLF.PlayMode.Append, priority: 0, callback: (pDidPlay) => {
                if (pDidPlay) {
                    FlyingGame.hasHeardFactVO[factVO] = true;
                }
            }});
        }

        if (data.sfx) {
            HLF.Application.instance.audio.play(data.sfx, 1, false, HLF.AudioCategory.SFX);
        }
    }

    protected startRestStopTimer(pDuration: number, pStartTime: number) {
        this.restStopTimeline?.kill();
        this.restStopTimeline?.clear();
        this.restStopTimeline = new TimelineLite();

        this.restStopTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_1, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 1/4);

        this.restStopTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_2, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 2/4);

        this.restStopTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_3, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 3/4);

        // stop spawning obstacles 3 seconds before we arrive at rest stop
        this.restStopTimeline.call(()=>{
            this.obstacleSpawnTimeline?.kill();
            this.obstacleSpawnTimeline?.clear();
        }, undefined, undefined, pDuration - 3);

        // pulse the progress bar marker
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 3);
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 2.5);
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 2);
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 1.5);
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 1);
        this.restStopTimeline.to(this.progressBar.nextRestStop!, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 0.5);

        this.restStopTimeline.to([this.upButton, this.downButton], 1, {
            y: this._size.y + 112.5,
            alpha: 0,
        }, pDuration);

        this.restStopTimeline.to(this.obstacles, 1.5, {
            pixi: {
                alpha: 0,
            },
        }, pDuration);

        this.restStopTimeline.to(this.progressBarContainer, 1, {
            y: -200,
        }, pDuration);

        this.restStopTimeline.call(()=>{
            const onVoComplete = ()=>{
                this.duckHoverTimeline?.kill();
                this.duckHoverTimeline?.clear();

                const flyDucksOffscreenTimeline = new TimelineLite();
                flyDucksOffscreenTimeline.to(this.ducks, 5, {
                    x: this._size.x,
                    y: this._size.y,
                });
                flyDucksOffscreenTimeline.call(()=>{
                    this.gotoNextState(RestStopGame.NAME);
                });
            }

            this.homeButton.setInteractive(false);
            this.settingsButton.setInteractive(false);
            this.helpButton.setInteractive(false);
            this.upButton.setInteractive(false);
            this.downButton.setInteractive(false);

            this.upButton.interactive = false;
            this.downButton.interactive = false;
            PubSub.publishSync(HLF.CLEAR_FOCUS);
            PubSub.publishSync(HLF.UNREGISTER_FOCUSABLES, [
                this.homeButton,
                this.settingsButton,
                this.helpButton,
                this.upButton,
                this.downButton,
            ]);

            if (RestStopGame.firstTime) {
                HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_6, {priority: 5, mode: HLF.PlayMode.Override, callback: onVoComplete});
            }
            else {
                HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_7, {priority: 5, mode: HLF.PlayMode.Override, callback: onVoComplete});
            }

            this.collisionsEnabled = false;

        }, undefined, undefined, pDuration);

        this.restStopTimeline!.time(pStartTime, true);
    }

    protected startRestoriaTimer(pDuration: number, pStartTime: number) {
        this.restoriaTimeline?.kill();
        this.restoriaTimeline?.clear();
        this.restoriaTimeline = new TimelineLite();

        this.restoriaTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_1, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 1/4);

        this.restoriaTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_2, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 2/4);

        this.restoriaTimeline.call(() => {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_KEEP_GOING_3, HLF.PlayMode.New);
        }, undefined, undefined, pDuration * 3/4);

        // stop spawning obstacles 3 seconds before we arrive at restoria
        this.restoriaTimeline.call(()=>{
            this.obstacleSpawnTimeline?.kill();
            this.obstacleSpawnTimeline?.clear();
        }, undefined, undefined, pDuration - 3);

        // pulse the progress bar marker
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 3);
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 2.5);
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 2);
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 1.5);
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1.05,
            },
        }, pDuration - 1);
        this.restoriaTimeline.to(this.progressBarDestinationIcon, 0.25, {
            pixi: {
                scale: 1,
            },
        }, pDuration - 0.5);

        this.restoriaTimeline.to([this.upButton, this.downButton], 1, {
            y: this._size.y + 112.5,
            alpha: 0,
        }, pDuration);
        this.restoriaTimeline.call(()=>{
            HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_8);
        });
        this.restoriaTimeline.to(this.obstacles, 1.5, {
            pixi: {
                alpha: 0,
            },
        }, pDuration);

        this.restoriaTimeline.to(this.progressBarContainer, 1, {
            y: -200,
        }, pDuration);

        this.restoriaTimeline.call(()=>{

            GameState.flightCount++;

            this.duckHoverTimeline?.kill();
            this.duckHoverTimeline?.clear();

            this.homeButton.setInteractive(false);
            this.settingsButton.setInteractive(false);
            this.helpButton.setInteractive(false);
            this.upButton.setInteractive(false);
            this.downButton.setInteractive(false);
            this.upButton.interactive = false;
            this.downButton.interactive = false;
            PubSub.publishSync(HLF.CLEAR_FOCUS);
            PubSub.publishSync(HLF.UNREGISTER_FOCUSABLES, [
                this.homeButton,
                this.settingsButton,
                this.helpButton,
                this.upButton,
                this.downButton,
            ]);

            this.collisionsEnabled = false;
            const flyDucksOffscreenTimeline = new TimelineLite();

            HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_9, {mode: HLF.PlayMode.Override, priority: 5, callback: ()=>{
                this.gotoNextState(ResultsScreen.NAME);
            }});

            flyDucksOffscreenTimeline.to(this.ducks, 5, {
                x: this._size.x,
                y: this._size.y,
            });

        }, undefined, undefined, pDuration);
        this.restoriaTimeline!.time(pStartTime, true);
    }

    protected destroyObstacle(pObstacle: FlyingGameObstacle, pIndex: number) {
        this.obstacles.splice(pIndex, 1);
        pObstacle.destroy();
    }

    protected onDuckCollidedWithObstacle(pDuck: FlyingGameDuck, pObstacle: FlyingGameObstacle) {
        pObstacle.dodged = false;
        const cooldown = 2; // seconds

        const energyDrainWhenTired = 10; // percent

        const duckReactTimeline = new TimelineLite();
        duckReactTimeline
            .call(()=>{
                pDuck.isColliding = true;
                if (pDuck.efficiency === 0) { // tired ducks take damage immediately
                    pDuck.energy -= energyDrainWhenTired;
                }
            })
            .add([
                TweenLite.to(pDuck.sprite, 0.25, {
                    pixi: {alpha: 0.3},
                }),
                TweenLite.to(pDuck, 0.25, {
                    pixi: {
                        x: pDuck.x - 10,
                    }
                }),
            ])
            .to(pDuck.sprite, 0.25, {
                pixi: {alpha: 0.8},
            })
            .to(pDuck.sprite, 0.125, {
                pixi: {alpha: 0.3},
            })
            .to(pDuck.sprite, 0.25, {
                pixi: {alpha: 0.8},
            })
            .to(pDuck.sprite, 0.125, {
                pixi: {alpha: 0.3},
            })
            .add([
                TweenLite.to(pDuck.sprite, 0.25, {
                    pixi: {alpha: 1},
                }),
                TweenLite.to(pDuck, 0.25, {
                    pixi: {
                        x: pDuck.x,
                    }
                }),
            ])
            .call(()=>{
                pDuck.isColliding = false;
            }, undefined, undefined, cooldown);

        if (this.hasCollidedWithAnObstacle === false && this.hasDodgedAnObstacle > 2) {
            HLF.Application.instance.voiceover.playVO(VO.FLYING_ONBOARDING_4, HLF.PlayMode.New, ()=>{
                this.hasCollidedWithAnObstacle = true;
            });
        }

        HLF.Application.instance.audio.play(SFX.COLLISION, 0.5, false, HLF.AudioCategory.SFX);

        if (FlyingGame.increaseDifficultyNextRound === true) {
            FlyingGame.increaseDifficultyNextRound = false;
        }
        if (FlyingGame.decreaseDifficultyNextRound === false) {
            FlyingGame.decreaseDifficultyNextRound = true;
        }
    }

    protected onSettingsPopupClosed(): void {
        super.onSettingsPopupClosed();
        PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, false);
    }

    protected onSettingsChanged(pTopic: typeof Topics.SETTINGS_CHANGED, pSettings: Readonly<typeof Settings>): void {
        super.onSettingsChanged(pTopic, pSettings);
        let speed: number;

        // if/else instead of switch because of floating point math
        if (Settings.obstacleSpeed < 1 / 7) {
            speed = 50;
        }
        else if (Settings.obstacleSpeed < 2 / 7) {
            speed = 50 * 1.5;
        }
        else if (Settings.obstacleSpeed < 3 / 7) {
            speed = 50 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 4 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 5 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 6 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else if (Settings.obstacleSpeed < 7 / 7) {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5;
        }
        else {
            speed = 50 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.5 * 1.25;
        }

        this.obstacles.forEach(o=>o.speed = speed);
    }

    protected onGamePaused() {
        HLF.LogUtils.log("onGamePaused", {className: FlyingGame.NAME, color: HLF.LogUtils.COLOR_LIGHT_BLUE});
        super.onGamePaused();
        this.duckHoverTimeline?.pause();
        if (!this.paused) {
            this.restStopTimeline?.pause();
            this.restoriaTimeline?.pause();
            this.laneChangeTimeline?.pause();
            this.obstacleSpawnTimeline?.pause();
            this.goToDuckSwapTimeline?.pause();
        }
    }

    protected onGameUnPaused() {
        HLF.LogUtils.log("onGameUnPaused", {className: FlyingGame.NAME, color: HLF.LogUtils.COLOR_LIGHT_BLUE});
        super.onGameUnPaused();
        this.duckHoverTimeline?.resume();
        if (!this.paused) {
            this.restStopTimeline?.resume();
            this.restoriaTimeline?.resume();
            this.laneChangeTimeline?.resume();
            this.obstacleSpawnTimeline?.resume();
            this.goToDuckSwapTimeline?.resume();
        }
    }

    protected playHelpVO(): void {
        HLF.Application.instance.voiceover.playVO(VO.FLYING_HELP);
    }

    private onKeyDown(pEvent: KeyboardEvent): void {
        if (Application.instance.paused) {
            return;
        }
        if (HLF.Input.KeyCode.isEventKey(pEvent, HLF.Input.KeyCodes.DOWN) || HLF.Input.KeyCode.isEventKey(pEvent, HLF.Input.KeyCodes.S)) {
            pEvent.preventDefault();
            this.onDownButtonPressed({fake: true});
            PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, false);
            PubSub.publishSync(HLF.CLEAR_FOCUS);
        }
        else if (HLF.Input.KeyCode.isEventKey(pEvent, HLF.Input.KeyCodes.UP) || HLF.Input.KeyCode.isEventKey(pEvent, HLF.Input.KeyCodes.W)) {
            pEvent.preventDefault();
            this.onUpButtonPressed({fake: true});
            PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, false);
            PubSub.publishSync(HLF.CLEAR_FOCUS);
        }
        else {
            PubSub.publishSync(HLF.GET_KEYBOARD_STATUS, (status: HLF.Input.IKeyboardStatus)=>{
                if (!status.enabled) {
                    PubSub.publishSync(HLF.SET_KEYBOARD_ENABLED, true);
                    pEvent.preventDefault();
                    if (this.upButton.interactive) {
                        PubSub.publishSync(HLF.FORCE_FOCUS, this.upButton);
                    }
                }
            });
        }
    }

    private layoutDucksInV (pOptions: {animate: boolean}) {
        const duckXSpacing = 45;
        let duckYSpacing = 10;
        if (this.ducks.length === 9) {
            duckYSpacing *= 1/2;
        }
        else if (this.ducks.length === 7) {
            duckYSpacing *= 2/3;
        }
        const laneChangeSpeed = 0.5;
        const delayBetweenDucks = 0.015;

        this.laneChangeTimeline.clear();

        for (let i = 0; i < this.ducks.length; i++) {
            const duck = this.ducks[i];
            if (i === 0) { // lead duck
                const x = (this.ducks.length + 1) * duckXSpacing;
                const y = this._size.y / 2 + laneData[this.currentLane].y;

                duck.x = x;
                if (pOptions.animate === true) {
                    this.laneChangeTimeline.to(duck, laneChangeSpeed, {pixi: {y}}, delayBetweenDucks * i);
                }
                else {
                    duck.y = y;
                }

            }
            else if ((i + 1) % 2 === 0) { // upper ducks (left side of v)
                const x = (this.ducks.length - i) * duckXSpacing;
                const y = this._size.y / 2 - duckYSpacing - (duckYSpacing * (i)) + laneData[this.currentLane].y;
                duck.x = x;
                if (pOptions.animate === true) {
                    this.laneChangeTimeline.to(duck, laneChangeSpeed, {pixi: {y}}, delayBetweenDucks * i);
                }
                else {
                    duck.y = y;
                }
            }
            else if ((i + 1) % 2 === 1) { // lower ducks (right side of v)
                const x = (this.ducks.length - (i - 1)) * duckXSpacing;
                const y = this._size.y / 2 + duckYSpacing + (duckYSpacing * (i - 1)) + laneData[this.currentLane].y;
                duck.x = x;
                if (pOptions.animate === true) {
                    this.laneChangeTimeline.to(duck, laneChangeSpeed, {pixi: {y}}, delayBetweenDucks * i);
                }
                else {
                    duck.y = y;
                }
            }
        }
    }

    private cleanupOffscreenObstacles() {

        const offscreenPos = (1024 - this._size.x) / 2;

        for (let i = this.obstacles.length - 1; i >= 0; --i) {
            const obstacle = this.obstacles[i];
            if (obstacle.x < offscreenPos - (obstacle.width / 2)) {
                if (obstacle.dodged === false) {
                    GameState.dodgedAllObstacles = false;
                }
                else {
                    obstacle.dodged = true;
                }
                this.destroyObstacle(obstacle, i);
            }
        }
    }

    private updateObstaclePositions(pDeltaTime: number) {
        for (let i = 0; i < this.obstacles.length; i++) {
            const obstacle = this.obstacles[i];
            obstacle.x -= obstacle.speed * pDeltaTime;
            if (this.hasDodgedAnObstacle === 0 && FlyingGame.firstTime === true && !GameState.freePlay && this.onboardingStep === 0) {
                if (obstacle.x < this.ducks[0].x + (this.ducks[0].width / 2) + 200) {
                    this.onboardingStep++;
                    console.log("onboarding -- pause game until player clicks up button");
                    this.upButton.pulse();

                    HLF.Application.instance.voiceover.playVO([
                        VO.FLYING_ONBOARDING_2,
                    ], HLF.PlayMode.Append);

                    this.currentLane = 1;
                    this.layoutDucksInV({animate: true});
                    this.downButton.setInteractive(false);
                    this.upButton.setInteractive(true);
                    this.pause();
                }
            }
            else if (this.hasDodgedAnObstacle === 1 && FlyingGame.firstTime === true && !GameState.freePlay && this.onboardingStep === 3) {
                if (obstacle.x < this.ducks[0].x + (this.ducks[0].width / 2) + 200 && obstacle.x > this.ducks[0].x) {
                    console.log("onboarding -- pause game until player clicks down button");
                    // force ducks to top lane
                    this.currentLane = 0;
                    this.layoutDucksInV({animate: true});
                    this.downButton.setInteractive(true);
                    this.upButton.setInteractive(false);
                    this.downButton.pulse();
                    this.pause();
                    this.onboardingStep++;
                    HLF.Application.instance.voiceover.playVO([VO.FLYING_ONBOARDING_5, VO.FLYING_ONBOARDING_6], HLF.PlayMode.Append);
                }
            }

            if (obstacle.x < this.ducks[0].x) {
                if (this.hasDodgedAnObstacle === 0 && FlyingGame.firstTime === true && !GameState.freePlay) {
                    console.log("onboarding: first successful dodge");
                    this.hasDodgedAnObstacle = 1;
                    this.upButton.interactive = false; // prevent player from interrupting the next vo
                    this.downButton.interactive = false;
                    PubSub.publishSync(HLF.CLEAR_FOCUS);
                    HLF.Application.instance.voiceover.playVO([VO.FLYING_ONBOARDING_3, obstacle.nameVO], {
                        caption: {
                            id: VO.FLYING_ONBOARDING_3,
                            args: {"OBSTACLE": obstacle.nameVO},
                        }, priority: 5, callback: ()=>{
                            this.spawnObstacle(0); // spawn second obstacle in top lane
                            this.upButton.interactive = true;
                            this.downButton.interactive = true;
                            this.onboardingStep++;
                            // from now on, obstacles spawn in a random lane
                            const delayBetweenObstacles = 9 * (1 - Settings.obstacleSpeed + 1/7);
                            this.obstacleSpawnTimeline!.clear();
                            this.obstacleSpawnTimeline!.call(()=>this.spawnObstacle(), undefined, undefined, delayBetweenObstacles);
                        }});
                }
                else if (this.onboardingStep === 4 && this.hasDodgedAnObstacle === 1 && FlyingGame.firstTime === true && !GameState.freePlay) {
                    console.log("onboarding: 2nd successful dodge");
                    console.log("flying game onboarding complete");
                    Application.instance.analytics.event("tutorial_complete", FlyingGame.NAME);
                    FlyingGame.firstTime = false;
                    this.downButton.setInteractive(true);
                    this.upButton.setInteractive(true);
                    this.settingsButton.visible = true;
                    this.helpButton.visible = true;
                    this.hasDodgedAnObstacle++;
                    this.onboardingStep++;
                }
                else if (this.ducks.some(d=>d.isColliding === true) === false && !this.goToDuckSwapTimeline?.isActive() && this.collisionsEnabled === true) {
                    if (this.hasDodgedAnObstacle === 2 && !GameState.freePlay) {
                        HLF.Application.instance.voiceover.playVO(VO.FLYING_ONBOARDING_7, {mode: HLF.PlayMode.New, callback: (pDidPlay: boolean)=>{
                            if (pDidPlay) {
                                this.hasDodgedAnObstacle++;
                            }
                        }});
                    }
                    else if (this.hasDodgedAnObstacle > 2 && FlyingGame.hasDodgedObstacleOfType[obstacle.name] !== true && (FlyingGame.firstTime === false || GameState.freePlay)) {
                        this.hasDodgedAnObstacle++;
                        FlyingGame.hasDodgedObstacleOfType[obstacle.name] = true;
                        if (HLF.Random.bool()) {
                            HLF.Application.instance.voiceover.playVO(VO.FLYING_INSTRUCTIONS_2, HLF.PlayMode.New);
                        }
                    }
                }
            }
        }
    }
}
